import { render, staticRenderFns } from "./IconFire.vue?vue&type=template&id=71120c94"
import script from "./IconFire.vue?vue&type=script&lang=js"
export * from "./IconFire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports